import Toast from "vue-toastification";
export default defineNuxtPlugin(({ vueApp }) => {
    vueApp.use(Toast, {});
});
